import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import {
  ButtonBox,
  LoadingBox,
  GridTable,
  TextBox,
  PrivilegesChecker,
} from "../index";
import {
  ActionTypeEnum,
  SearchCustomerResponseModel,
  SearchBeneficiaryRequestModel,
  RequestActionModel,
  SearchCustomersTypeEnum,
  SupplierCustomerTypeEnum,
  HasFormIdModel,
} from "../../models";
import { getLabelName, isArabicCurrentLanguage } from "../../utils";
import { searchCustomers } from "../../serviceBroker/customerApiServiceBroker";

interface BeneficiaryModel extends HasFormIdModel {
  type: SupplierCustomerTypeEnum;
  onActionEvent: (o: RequestActionModel) => void;
  setIsRefresh: Dispatch<SetStateAction<boolean>>;
  isRefresh: boolean;
}
export const BeneficiaryList: FC<BeneficiaryModel> = ({
  type = SupplierCustomerTypeEnum.Customer,
  onActionEvent = () => {},
  setIsRefresh,
  isRefresh,
  formId,
}) => {
  //#region variables
  const defaultPageSize: number = 50;
  const initialValues: SearchBeneficiaryRequestModel = {
    pageNumber: 1,
    type: type,
    pageSize: defaultPageSize,
    searchType: SearchCustomersTypeEnum.CustomerName,
    searchValue: null,
  };
  //#endregion
  //#region state
  const [data, setData] = useState<{
    data: SearchCustomerResponseModel[];
    totalRecordsCount: number;
  }>({
    data: [],
    totalRecordsCount: 0,
  });
  const [searchRequest, setSearchRequest] =
    useState<SearchBeneficiaryRequestModel>(initialValues);
  const [loading, setLoading] = useState(false);
  //#endregion
  //#region useEffect
  useEffect(() => {
    const fillData = async () => {
      if (isRefresh) {
        await handleSearch();
        setIsRefresh(false);
      }
    };
    fillData().then(() => {});
  }, [isRefresh]);
  useEffect(() => {
    const fillData = async () => {
      await handleSearch();
    };
    fillData().then(() => {});
  }, []);
  //#endregion
  //#region functions
  const fetchData = async (searchModel: SearchBeneficiaryRequestModel) => {
    setLoading(true);
    const result = await searchCustomers(searchModel);
    setData({
      data: result?.Result || [],
      totalRecordsCount: result?.TotalRecoredCount || 0,
    });
    setLoading(false);
  };
  const handleSearch = async () => {
    setLoading(true);
    await fetchData(searchRequest);
    setLoading(false);
  };
  const handleResetSearch = async () => {
    setLoading(true);
    setSearchRequest({ ...initialValues });
    await fetchData(initialValues);
    setLoading(false);
  };
  const onCurrentPageChange = async (pageNumber: number) => {
    if (pageNumber !== searchRequest.pageNumber) {
      const obj = { ...searchRequest };
      obj.pageNumber = pageNumber;
      setSearchRequest(obj);
      searchRequest.pageNumber = pageNumber;
    }
    await fetchData(searchRequest);
  };
  const onPageSizeChange = async (pageSize: number) => {
    if (pageSize !== searchRequest.pageSize) {
      const obj = { ...searchRequest };
      obj.pageSize = pageSize;
      setSearchRequest(obj);
      searchRequest.pageSize = pageSize;
    }
    await fetchData(searchRequest);
  };
  //#endregion
  //#region html
  return (
    <>
      {loading && <LoadingBox />}
      <PrivilegesChecker formId={formId} action="EnableSearch">
        <div
          //style={{ maxWidth: "50%" }}
          className="col-12 d-flex justify-content-start my-4 mt-0"
        >
          <TextBox
            labelName={getLabelName("")} //{getLabelName("lookup.nameAr")}
            inputName={"searchValue"}
            inputValue={searchRequest.searchValue || ""}
            onChange={(e: any) => {
              setSearchRequest({
                ...searchRequest,
                searchValue: e.target.value,
              });
            }}
          />
          <ButtonBox
            type="submit"
            className="btn-gradient-primary mx-3"
            variant=""
            onClick={async () => {
              await handleSearch();
            }}
          >
            {getLabelName("Search")}
          </ButtonBox>
          <ButtonBox
            iconType="receipt"
            variant="danger"
            type="button"
            className="mx-3"
            onClick={async () => {
              await handleResetSearch();
            }}
          >
            {getLabelName("Cancel")}
          </ButtonBox>
        </div>
      </PrivilegesChecker>

      <GridTable
        formId={formId}
        data={data.data}
        totalRows={data.totalRecordsCount}
        externalLoading={loading}
        currentPage={searchRequest.pageNumber || 1}
        pageSize={searchRequest.pageSize || defaultPageSize}
        onCurrentPageChange={onCurrentPageChange}
        onPageSizeChange={onPageSizeChange}
        paginationType="server"
        columnsProps={{
          actions: [ActionTypeEnum.Update, ActionTypeEnum.Delete],
          isArabic: isArabicCurrentLanguage(),
          onActionEvent,
        }}
      />
    </>
  );
  //#endregion
};
